/**
 * Format integer cents as USD with grouping separators, e.g. 268800 → "$2,688.00".
 */
export function formatUsdFromCents(cents) {
  const n = Number(cents);
  if (cents == null || Number.isNaN(n)) return '$0.00';
  return (n / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}
